<!--
 * @Author: your name
 * @Date: 2021-06-22 13:59:06
 * @LastEditTime: 2022-09-21 14:17:30
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\AttrList\AttrMedia.vue
-->
<!--流媒体-->

<template>
  <div class="attr-media">
    <div class="media-item flex-b-c">
      <span class="media-attr">{{$t('PE.Name')}}</span>
      <span>{{$t('PE.StreamMedia')}}</span>
    </div>
    <div class="media-item flex-b-c">
      <el-input :placeholder="$t('basics.PleaseInput')" v-model="media.ext_val_url" size="mini">
        <template slot="prepend">URL</template>
      </el-input>
    </div>
    <div class="media-item flex-b-c">
      <span class="media-attr">{{$t('PE.Scale')}}</span>
      <el-checkbox v-model="media.ext_val_scaleType">{{$t('PE.ConstrainProportions')}}</el-checkbox>
    </div>
    <div class="media-item flex-b-c">
      <span class="media-attr">{{$t('PE.EnterTheAnimation')}}</span>
      <el-select v-model="media.ext_val_anim" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
        <el-option v-for="item in animations" :key="item.id" :label="$t(item.i18n)" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="media-item flex-b-c">
      <span class="media-attr">{{$t('PE.TheEntryTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_enterTime" :min="1" size="mini"></el-input-number>
    </div>
    <div class="media-item flex-b-c">
      <span class="media-attr">{{$t('PE.PlayTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_duration" :min="1" size="mini"></el-input-number>
    </div>
  </div>
</template>

<script>
import animations from '../../scripts/animations';
export default {
  name: "AttrMedia",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      animations,
      checked: false,
      num: 10,
    }
  },
  mounted() {
    console.log(this.media);
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.attr-media {
  padding-right: 4px;
  .media-item {
    min-height: 36px;
    margin: 8px 0px;
    // .media-attr {
    //   font-family: 'Times New Roman';
    //   font-weight: normal;
    //   font-stretch: normal;
    //   color: #617883;
    // }
  }
}
</style>